import { customAxios } from '../../common/customAxios';
import { myOwnTractorsApiUrl } from '../queries/getMyOwnTractors';
import { FeedbackRating } from '../../../pages/MyInfo/MyInfoOwnTractorDetailPage/components/FeedbackPopupBody';
interface patchPokeRatingParams {
  ownTractorId: string;
  pokeId: string;
  reqBody: {
    pokeRating: FeedbackRating;
  };
}

export const patchPokeRating = ({ ownTractorId, pokeId, reqBody }: patchPokeRatingParams): Promise<void> => {
  return customAxios.patch(`${myOwnTractorsApiUrl}/${ownTractorId}/pokes/${pokeId}/rating`, reqBody);
};
